<template>
  <nav class="nav">
    <div class="wrapper">
      <h3 class="title">{{ getTitle() }}</h3>

      <div class="user">
        <span class="email">
          {{ user.email }}
        </span>
        <span
          class="logout"
          @click="logout"
        >
          {{ $t('layout.navigation.logout') }}
        </span>
      </div>

      <a
        href="/ustawienia"
        class="settings"
      >
        <font-awesome-icon icon="gear"/>
      </a>
    </div>
  </nav>
</template>

<style scoped>
  .nav {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 60px;
    box-sizing: border-box;
    padding: 10px 20px;
    color: var(--primary-text-color-white);
    background-color: var(--tertiary-color);
    z-index: 100;
  }

  .wrapper {
    display: flex;
    justify-content: flex-end;
    align-items: center;
    height: 100%;
    max-width: 1200px;
  }

  .title {
    margin: 0;
    padding: 0;
    font-size: 1.3rem;
    text-transform: uppercase;
  }

  .user {
    position: relative;
    margin-left: auto;
    font-size: 1.2rem;
    font-weight: 600;
    text-align: center;
  }

  .email {
    display: block;
  }

  .logout {
    position: relative;
    cursor: pointer;
    font-size: 1.2rem;
    font-weight: 600;
    text-transform: none;
  }

  .logout::before {
    content: '';
    position: absolute;
    left: 0;
    bottom: -2px;
    display: block;
    width: 0%;
    height: 1px;
    background-color: var(--primary-text-color-white);
    transition: width 0.2s;
  }

  .logout:hover::before {
    width: 100%;
  }

  .settings {
    margin-left: 10px;
    font-size: 1.8rem;
    color: var(--tertiary-text-color);
    transition: color 0.2s;
  }

  .settings:active {
    color: var(--primary-color);
  }

  .settings:hover,
  .settings:focus {
    color: var(--secondary-color);
  }
</style>

<script>
  export default {
    props: [ 'user' ],
    methods: {
      getTitle() {
        switch (window.location.pathname) {
          case '/':
            return this.$t('layout.navigation.heading.homePage');
          case '/ustawienia':
            return this.$t('layout.navigation.heading.settingsPage');
          case '/nowe-zgloszenie':
            return this.$t('layout.navigation.heading.orderCreatePage');
          case '/do-potwierdzenia':
            return this.$t('layout.navigation.heading.orderListAwaitingAcceptancePage');
          case '/nieprzypisane-zgloszenia':
            return this.$t('layout.navigation.heading.orderListUnassignedPage');
          case '/moje-zgloszenia':
            return this.$t('layout.navigation.heading.orderListUserPage');
          case '/wszystkie-zgloszenia':
            return this.$t('layout.navigation.heading.orderListAllPage');
        }

        const matchOrderRoute = window.location.pathname.match((/\/zgloszenie\/(.*)/));

        if (matchOrderRoute) {
          return `${this.$t('layout.navigation.heading.orderPage')} #${matchOrderRoute[1]}`;
        }
      },
      logout: async function() {
        this.$emit('logout');
      }
    }
  }
</script>
